<template>
  <div style="height: 100%">
    <!--      头部      -->
    <div class="iq-top-navbar">
      <el-page-header @back="$router.go(-1)" content="订单评论"> </el-page-header>
    </div>
    <!--    内容    -->
    <div class="center-content">
      <div class="iq-card-body">
        <div class="table-top">
          <div class="iq-search-bar">
            <el-form :model="searchForm" :inline="true">
              <el-form-item>
                <el-button
                  type="primary"
                  size="mini"
                  @click="
                    searchForm.star = 0;
                    search();
                  "
                  plain
                  >全部</el-button
                >
              </el-form-item>
              <el-form-item>
                <el-rate v-model="searchForm.star" text-color="#ff9900" show-text :texts="texts" @change="search"> </el-rate>
              </el-form-item>
              <el-form-item>
                <el-input v-model="searchForm.keyWord" type="text" size="small" placeholder="输入购买人搜索..." @keyup.enter.native="search" clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="search()">搜索</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <el-table :data="tableData" stripe height="calc(100% - 80px)" :default-expand-all="true" style="width: 100%" :header-cell-style="{ background: '#F5F7FC' }">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="padding: 0 55px;">
                <div class="color-red">{{ scope.row.userName }}：</div>
                <div>{{ scope.row.content }}</div>
                <div class="flex-start flex-wrap" v-if="scope.row.fileUrls">
                  <el-image hide-on-click-modal :src="CommonPath + itemphoto" preview-teleported :zoom-rate="1.2" :preview-src-list="[CommonPath + itemphoto]" v-for="(itemphoto, index) in scope.row.fileUrls.split(',')" style="width: 100px; height: 100px; margin-right: 5px" fit="cover" :key="index"></el-image>
                </div>
                <div class="color-red" v-if="scope.row.replyContent" style="margin-top: 10px">店铺回复：{{ scope.row.userName }}</div>
                <div>{{ scope.row.replyContent }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderCommodityDetail.sonOrderNumber" label="订单编号"> </el-table-column>
          <el-table-column prop="orderCommodityDetail.commodity.name" label="商品名称" align="center"> </el-table-column>
          <el-table-column prop="orderCommodityDetail.commoditySpecifications.name" label="规格"> </el-table-column>
          <el-table-column label="订单信息" align="center">
            <template slot-scope="scope">
              <div class="orderprovos-box">￥{{ scope.row.orderCommodityDetail.actualMoney }}*{{ scope.row.orderCommodityDetail.commodityNum }}</div>
            </template>
          </el-table-column>
          <el-table-column label="好/中/差评" align="center">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.star" text-color="#ff9900" disabled show-text :texts="texts"> </el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="提交时间" width="160px" align="center" sortable>
            <template slot-scope="scope">
              <p>{{ scope.row.createTime | timefilters }}</p>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <span v-if="!scope.row.replyContent" class="primary optionBtn" @click="ReplyBtn(scope.row)">回复</span>
              <span v-else class="info optionBtn">已回复</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="ChangePage" :page-size="PageSize" :current-page="PageIndex" :total="DataTotal" layout="total, prev, pager, next, jumper"></el-pagination>
      </div>
    </div>
    <el-dialog title="回复评论" :visible.sync="dialogFormVisible" width="500px">
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item prop="replyContent">
          <el-input type="textarea" :autosize="{ minRows: 4 }" v-model="form.replyContent" autocomplete="off"> </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveBtn('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Order } from "../../../components/HospitalDomain/ShopMall/Order";
import bread from "../../../components/common/breadcrumb";

export default {
  name: "Order",
  components: {
    bread,
  },
  data() {
    var order = new Order(this.TokenClient, this.Services.Shopping);
    return {
      OrderDomain: order,
      searchForm: {
        statrTime: "",
        endTime: "",
        keyWord: "",
        datepicker: "",
        star: 0,
      },
      httpContent: this.Services.Authorization,
      PageIndex: 1,
      PageTotal: 1,
      PageSize: 15,
      DataTotal: 0,
      texts: ["差评", "差评", "中评", "中评", "好评"],
      keyWord: "",
      pickerOptions0: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      tableData: [],
      dialogFormVisible: false,
      form: {
        id: "",
        replyContent: "",
      },
      rules: {
        replyContent: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var _this = this;
      _this.tableData = [];
      _this.OrderDomain.OrderEvaluateList(
        _this.searchForm.star,
        _this.searchForm.keyWord,
        _this.PageIndex,
        function (data) {
          _this.tableData = data.data.results;
          _this.PageIndex = data.data.pageIndex;
          _this.PageSize = data.data.pageSize;
          _this.PageTotal = data.data.pageCount;
          _this.DataTotal = data.data.dataTotal;
        },
        function (error) {
          console.log(error);
        }
      );
    },
    search(e) {
      this.PageIndex = 1;
      this.getList();
    },
    ChangePage(pageIndex) {
      this.PageIndex = pageIndex;
      this.getList();
    },
    ReplyBtn(item) {
      this.form.id = item.id;
      this.dialogFormVisible = true;
    },
    saveBtn(formName) {
      var _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.OrderDomain.OrderEvaluateReplay(
            _this.form,
            function (data) {
              _this.dialogFormVisible = false;
              _this.$refs[formName].resetFields();
              _this.PageIndex = 1;
              _this.getList();
            },
            function (err) {
              console.log(err);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
/*content*/

.table-top {
  margin-bottom: -10px;
}

.color-red {
  color: red;
  margin-right: 20px;
}

.iq-search-bar .searchbox .el-input {
  width: 300px;
}
.iq-search-bar ::v-deep .el-rate {
  font-size: 35px;
}
.info-item .el-image {
  width: 80px;
  height: 100px;
  vertical-align: middle;
  margin-right: 10px;
  margin-bottom: 5px;
}
</style>
